var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClipboardMedical(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.077,
    height: 23.479,
    viewBox: "0 0 19.077 23.479",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_27489",
    "data-name": "Caminho 27489",
    d: "M150.679,32.476V17.068a2.2,2.2,0,0,0-2.2-2.2h-3.669a3.669,3.669,0,1,0-7.337,0H133.8a2.2,2.2,0,0,0-2.2,2.2V32.476a2.2,2.2,0,0,0,2.2,2.2h14.674a2.2,2.2,0,0,0,2.2-2.2Zm-8.8-2.2h-6.6v-2.2h6.6Zm5.136-4.4H135.27v-2.2H147.01Zm0-4.4H135.27v-2.2H147.01Z",
    transform: "translate(-131.602 -11.198)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClipboardMedical);
export default __webpack_public_path__ + "static/media/clipboard-medical.edfbba0eb7167d5068d0110aef9a0022.svg";
export { ForwardRef as ReactComponent };